import React from 'react';
import {CloseButton, Flex} from '@chakra-ui/react';
import {FilterSelect, FilterSelectHeight} from './FilterSelect';

const filterSelectionOptions = {
  include: {label: 'include any of', value: false},
  exclude: {label: 'exclude any of', value: true},
};

export function FilterControlWithNegate<T>({
  value,
  negate,
  onChange,
  onRemove,
  children,
}: {
  value: T;
  negate?: boolean;
  onChange: (value: T, negate?: boolean) => void;
  onRemove: () => void;
  children: (value: T, onValueChange: (newValue: T) => void) => React.ReactNode;
}) {
  const handleValueChange = (newValue: T) => {
    onChange(newValue, negate);
  };

  const handleNegateChange = (newNegate: boolean) => {
    onChange(value, newNegate);
  };

  return (
    <Flex gap="2" flex={2} alignItems="flex-start">
      <FilterSelect
        variant="operator"
        options={Object.values(filterSelectionOptions)}
        value={
          negate
            ? filterSelectionOptions.exclude
            : filterSelectionOptions.include
        }
        onChange={(selected) => {
          if (selected) {
            handleNegateChange(selected.value);
          }
        }}
      />
      {children(value, handleValueChange)}
      <Flex height={FilterSelectHeight} alignItems="center">
        <CloseButton onClick={onRemove} />
      </Flex>
    </Flex>
  );
}
